import api from '@pray/shared/utils/api';

import type { CoverArtsResponse, SaveCoverArtsRequest } from './types';

type SaveCoverArtsProps = {
  artistId: string;
  coverArts: SaveCoverArtsRequest;
};

export const saveCoverArts = async ({ artistId, coverArts }: SaveCoverArtsProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!coverArts) throw Error('Cover arts are required');

  const url = `/web/studio/artists/${artistId}/cover-arts`;
  const response = await api.executePostRequest<CoverArtsResponse>(url, coverArts);

  return response?.data;
};
